<nav class="modern-navbar navbar navbar-expand-lg sticky-top" role="navigation" [class.scrolled]="isScrolled">
  <div class="container px-5">
    <!-- Logo con animación -->
    <a class="navbar-brand p-0 m-0" routerLink="/inicio">
      <div class="logo-container">
        <img src="assets/brand/logo.png" alt="Grupo Dingo" class="nav-logo">
        <div class="logo-glow"></div>
      </div>
    </a>

    <!-- Botón hamburguesa moderno -->
    <button class="navbar-toggler modern-toggler" type="button" [class.active]="!isCollapsed" (click)="toggleMenu()"
      aria-label="Toggle navigation">
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </button>

    <!-- Menú de navegación -->
    <div class="collapse navbar-collapse" [class.show]="!isCollapsed">
      <ul class="navbar-nav ms-auto modern-nav-list">
        <li class="nav-item" *ngFor="let item of menuItems; let i = index">
          <a class="nav-link modern-link" [routerLink]="item.route" routerLinkActive="active" (click)="closeMenu()"
            [attr.data-text]="item.text">
            <span class="link-text">{{ item.text }}</span>
            <span class="link-icon">
              <i [class]="item.icon"></i>
            </span>
          </a>
        </li>

        <!-- Botón CTA -->
        <li class="nav-item cta-item">
          <a class="nav-link cta-button" routerLink="/contacto" (click)="closeMenu()">
            <span>Contáctanos</span>
            <i class="bi bi-envelope"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Indicador de progreso -->
  <div class="scroll-progress" [style.width.%]="scrollProgress"></div>
</nav>
